import { BasicEvent } from "../../../planera/events/BasicEvent";
export class ArbetsorderTransportforetagUpdatedMessage extends BasicEvent {
    transportforetagId: number;
    arbetsorderIds: number[];
    arbetsordersWithValsWarning: number[];
    arbetsordrarSkickadeTillViol: number[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderTransportforetagUpdatedMessage";
    constructor() {
        super(ArbetsorderTransportforetagUpdatedMessage.$type);
    }
}
